import {
  BuildingActiveStateFilter,
  building_state_enum,
  class_of_use_enum,
  efficiency_class_enum,
  energy_certificate_type_enum,
  energy_source_type_enum,
  eu_taxonomy_compliance_enum,
  tax_bracket_enum,
  type_of_use_enum,
} from '@predium/enums';
import { parseAsArrayOf, parseAsBoolean, parseAsFloat, parseAsInteger, parseAsJson, parseAsStringEnum } from 'nuqs';
import { parseCustomFieldFilters } from './custom-field-filters';

export type BuildingFiltersSearchParams = keyof typeof BUILDING_FILTERS_SEARCH_PARAMS;

export const BUILDING_FILTERS_SEARCH_PARAMS = {
  portfolioIds: parseAsArrayOf(parseAsInteger),
  economicUnitIds: parseAsArrayOf(parseAsInteger),
  buildingIds: parseAsArrayOf(parseAsInteger),
  excludedBuildingIds: parseAsArrayOf(parseAsInteger),
  classOfUses: parseAsArrayOf(parseAsStringEnum<class_of_use_enum>(Object.values(class_of_use_enum))),
  typeOfUses: parseAsArrayOf(parseAsStringEnum<type_of_use_enum>(Object.values(type_of_use_enum))),
  efficiencyClasses: parseAsArrayOf(parseAsStringEnum<efficiency_class_enum>(Object.values(efficiency_class_enum))),
  energyCertificateTypes: parseAsArrayOf(
    parseAsStringEnum<energy_certificate_type_enum>(Object.values(energy_certificate_type_enum)),
  ),
  noEnergyCertificate: parseAsArrayOf(parseAsBoolean),
  energySourceTypes: parseAsArrayOf(parseAsStringEnum<energy_source_type_enum>(Object.values(energy_source_type_enum))),
  taxBrackets: parseAsArrayOf(parseAsStringEnum<tax_bracket_enum>(Object.values(tax_bracket_enum))),
  euTaxonomyCompliance: parseAsArrayOf(
    parseAsStringEnum<eu_taxonomy_compliance_enum>(Object.values(eu_taxonomy_compliance_enum)),
  ),
  monumentProtections: parseAsArrayOf(parseAsBoolean),
  heritageDistrict: parseAsArrayOf(parseAsBoolean),
  milieuProtection: parseAsArrayOf(parseAsBoolean),
  leasehold: parseAsArrayOf(parseAsBoolean),
  actionPlanningAvailable: parseAsArrayOf(parseAsBoolean),
  districtHeatingAvailability: parseAsArrayOf(parseAsBoolean),
  buildingStates: parseAsArrayOf(parseAsStringEnum<building_state_enum>(Object.values(building_state_enum))),
  minPrimaryEnergy: parseAsFloat,
  maxPrimaryEnergy: parseAsFloat,
  minCo2Emissions: parseAsFloat,
  maxCo2Emissions: parseAsFloat,
  minFinalEnergy: parseAsFloat,
  maxFinalEnergy: parseAsFloat,
  minStrandingYear: parseAsInteger,
  maxStrandingYear: parseAsInteger,
  activeStateFilter: parseAsStringEnum<BuildingActiveStateFilter>(Object.values(BuildingActiveStateFilter)),
  hasConsumptionData: parseAsBoolean,
  isLod2: parseAsArrayOf(parseAsBoolean),
  responsibleUserIds: parseAsArrayOf(parseAsInteger),
  economicUnitResponsibleUserIds: parseAsArrayOf(parseAsInteger),
  slfCompliant: parseAsBoolean,
  customFields: parseAsJson(parseCustomFieldFilters),
} as const;

export const RESET_BUILDING_MORE_FILTERS_SEARCH_PARAMS: Record<
  Exclude<BuildingFiltersSearchParams, 'portfolioIds' | 'economicUnitIds' | 'buildingIds'>,
  null
> = {
  excludedBuildingIds: null,
  classOfUses: null,
  typeOfUses: null,
  efficiencyClasses: null,
  energyCertificateTypes: null,
  noEnergyCertificate: null,
  energySourceTypes: null,
  taxBrackets: null,
  euTaxonomyCompliance: null,
  monumentProtections: null,
  heritageDistrict: null,
  milieuProtection: null,
  leasehold: null,
  actionPlanningAvailable: null,
  districtHeatingAvailability: null,
  buildingStates: null,
  minPrimaryEnergy: null,
  maxPrimaryEnergy: null,
  minCo2Emissions: null,
  maxCo2Emissions: null,
  minFinalEnergy: null,
  maxFinalEnergy: null,
  minStrandingYear: null,
  maxStrandingYear: null,
  activeStateFilter: null,
  hasConsumptionData: null,
  isLod2: null,
  responsibleUserIds: null,
  economicUnitResponsibleUserIds: null,
  slfCompliant: null,
  customFields: null,
} as const;

export const RESET_ALL_BUILDING_FILTERS_SEARCH_PARAMS: Record<BuildingFiltersSearchParams, null> = {
  ...RESET_BUILDING_MORE_FILTERS_SEARCH_PARAMS,
  portfolioIds: null,
  economicUnitIds: null,
  buildingIds: null,
};
